var Colors = ["#004500", "black", "#FF00FF", "#FF0000", "#FFFF00", "#00FF00", "#00FFFF", "#0000FF", "#764710", "#FF8000"];

export default Colors;


// WEBPACK FOOTER //
// ./src/components/colors.js